module.exports = __webpack_public_path__ + "../resources/img/ic_down_arrow.f11c45e3.svg";